import { render, staticRenderFns } from "./activityData.vue?vue&type=template&id=04ffd094&scoped=true"
import script from "./activityData.vue?vue&type=script&lang=js"
export * from "./activityData.vue?vue&type=script&lang=js"
import style0 from "./activityData.vue?vue&type=style&index=0&id=04ffd094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ffd094",
  null
  
)

export default component.exports